import { Component, computed, inject, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService } from './core/services/utility.service';
import { Helperclass } from './core/class/helperclass';
import { Router } from '@angular/router';
import { UiFeedbackService } from './core/services/ui-feedback.service';
import { MatDrawer } from '@angular/material/sidenav';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  readonly #uiFeedback = inject(UiFeedbackService);

  readonly showLayout = computed(() => this.#uiFeedback.showPrincipalLayout());


  title = 'Admintrador-Ofertas-Promociones';
  showFiller = false;
  showSpinner = false;
  loginIs = false;


  @ViewChild('drawer') drawer!: MatDrawer;


  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private UtilityService: UtilityService,
    private helperClass: Helperclass
  ) {
    this.UtilityService.IsSpinner$.subscribe(data => this.showSpinner = data);
    this.UtilityService.IsLogin$.subscribe(data => {
      console.log(data);
      this.loginIs = data
    });
    iconRegistry
      .addSvgIcon('ic-eye', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/eye.svg'))
      .addSvgIcon('ic-close', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/close-line.svg'))
      .addSvgIcon('ic-trash', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/trash.svg'))
      .addSvgIcon('ic-check', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/Vector.svg'))
      .addSvgIcon('ic-actualizar', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/actualizar.svg'))
      .addSvgIcon('ic-edit', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/edit.svg'))
      .addSvgIcon('ic-filter', sanitizer.bypassSecurityTrustResourceUrl('assets/svg/filter.svg'));
  }
  outputlogin(option) {
    this.loginIs = option;
  }

  ngOnInit(): void {
    const getMenu = JSON.parse(sessionStorage.getItem('menu') || '[]');

    if (getMenu.length > 0) {
      this.helperClass.setActiveModules(getMenu);
    } else {
      sessionStorage.clear();
    }

    this.#showChangePasswordModal();
  }


  onCancel() {
    this.#uiFeedback.configurateResetPasswordModal({ visible: false, showCancelButton: false, initialOldPassword: '' });
    sessionStorage.clear();
  }


  #showChangePasswordModal() {
    if (sessionStorage.getItem('firstLogin')) {
      sessionStorage.clear();
    }
  }
}
